import React, { useCallback, useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { CaretClosure, IconesFilterMobile } from "@routes/IconeSvg";

import { Disclosure } from "@headlessui/react";

import ThreeDotsLoader from "@components/loader/Loading";
import Button from "@components/tailwindComponents/Button";
import EmptyData from "@components/tailwindComponents/EmptyData";

import ModalMileinageRequest from "../../components/modals/MileageRequest";
import ModalNewRequest from "../../components/modals/NewRequest";
import { useExpenses } from "../../utils/hooks";
import ButtonAddCard from "../Components/ButtonAddCard";
import Items from "../Components/itemCardMobile";
import { ExpensesContext } from "../context";
import ModalFilterMobile from "./modalFilter";

export default function Index() {
  const { t, i18n } = useTranslation("expenses.reimbursment");
  const [isOpen, setIsOpen] = useState(false);
  const [showModalRequest, setShowNewRequest] = useState(false);
  const [showMileageReimbursment, setShowMileageReimbursment] = useState(false);
  const onClickClose = () => {
    setIsOpen(!isOpen);
  };
  const _reimbursmentsLists = useContext(ExpensesContext);
  const { filterLoading, getDataFilter, reimbursmentsFiltered, drafts, filtersLists } =
    useExpenses(_reimbursmentsLists);
  const onClickNewRequest = useCallback(() => {
    setShowNewRequest((showModalRequest) => !showModalRequest);
  }, []);
  const onClickFilter = async (data, dateChanged) => {
    await getDataFilter(data, dateChanged);
    setIsOpen(false);
  };
  const onAddClickMileageReimbursment = useCallback(() => {
    setShowMileageReimbursment(
      (showMileageReimbursment) => !showMileageReimbursment,
    );
  }, []);

  return (
    <>
      <div className="arh-flex arh-flex-col arh-space-y-2">
        <div className="arh-flex arh-w-full arh-justify-between">
          <div className="arh-font-poppins arh-text-lg arh-font-bold arh-text-darkColor">
            {t("Remboursements")}
          </div>
          <div>
            <Button
              variant="green-outlined"
              className="!arh-border-0 "
              onClick={() => setIsOpen(!isOpen)}
            >
              {IconesFilterMobile()}
            </Button>
          </div>
        </div>
        <ButtonAddCard
          title={t("Ajouter une demande")}
          onClick={onClickNewRequest}
        />
        <ButtonAddCard
          title={t("Remboursement kilométrique")}
          onClick={onAddClickMileageReimbursment}
        />
        <Disclosure defaultOpen={false}>
          {({ open }) => (
            <div className="arh-overflow-hidden arh-rounded-[4px] arh-border arh-border-solid arh-border-greyBorderBtn">
              <Disclosure.Button className="arh-flex arh-h-8 arh-w-full arh-items-center arh-justify-between arh-border-0 arh-bg-white arh-px-3 arh-text-left">
                <span className="arh-font-poppins arh-text-[10px] arh-font-medium arh-text-darkColor">
                  <span>{t("Brouillons en attente")}</span>
                </span>
                <span className="arh-flex arh-items-center arh-space-x-2">
                  <span className="arh-flex arh-h-4 arh-min-w-4 arh-items-center arh-justify-center arh-rounded-full arh-border arh-border-solid arh-border-greenColor arh-px-1 arh-font-poppins arh-text-[9px] arh-text-greenColor">
                    {drafts?.length || 0}
                  </span>
                  <CaretClosure
                    className={open ? "arh-rotate-0" : "-arh-rotate-90"}
                    aria-hidden="true"
                  />
                </span>
              </Disclosure.Button>
              <Disclosure.Panel className="arh-flex arh-flex-col arh-space-y-2 arh-p-2">
                {drafts?.map((draft) => (
                  <Items
                    expense={draft}
                    key={draft?._id}
                    i18n={i18n}
                    defaultOpen={true}
                    isDraft
                  />
                ))}
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
        {filterLoading ? (
          <ThreeDotsLoader
            class="inherit_from_parent"
            color="#73C7B7"
            height="100"
            width="100"
          />
        ) : reimbursmentsFiltered?.length ? (
          reimbursmentsFiltered?.map((_expense) => (
            <Items expense={_expense} key={_expense?._id} i18n={i18n} />
          ))
        ) : (
          <EmptyData>{t("Aucun élément")}</EmptyData>
        )}
      </div>
      <ModalFilterMobile
        isOpen={isOpen}
        onClickClose={onClickClose}
        t={t}
        setDataFilter={onClickFilter}
        filtersLists={filtersLists}
      />
      <ModalNewRequest
        show={showModalRequest}
        onClickClose={onClickNewRequest}
      />

      <ModalMileinageRequest
        isOpen={showMileageReimbursment}
        toggle={onAddClickMileageReimbursment}
        onClickClose={onAddClickMileageReimbursment}
        t={t}
      />
    </>
  );
}
